
import { Mixins, Component } from "vue-property-decorator";
import tablePagination from "@/mixins/tablePagination";
import ETable from "@/components/ETable.vue";
import loading from "@/mixins/loading";
import EditDialog from "./components/editDialog.vue";
import {
  getWeigherMetabolismConfigPage,
  getWeigherMetabolismConfigFilterOptions
} from "@/api/weigherMetabolismConfig";
import { formatTextarea } from "@/utils/common";

@Component({ name: 'ai-evaluation-weight-index',
  components: { ETable, EditDialog }
})
export default class AiEvaluationWeight extends Mixins(loading, tablePagination) {
  queryForm = {
    tongueConstitution: "",
    bodyFatType: ""
  };

  itemTotal = 0;
  tableData = [];
  currentRow: any = null;
  EditDialogVisible = false;

  tongueConstitutionOptions: { label: string; value: string }[] = [];
  bodyFatTypeOptions: { label: string; value: string }[] = [];

  columns = [
    { label: "ID", prop: "id", width: "80px" },
    { label: "舌诊体质", prop: "resultKey1", width: "100px" },
    { label: "体脂体型", prop: "resultKey2", width: "120px" },
    { label: "症状", prop: "symptoms", minWidth: "200px" },
    { label: "原因", prop: "reasons", minWidth: "200px" },
    { label: "预防疾病", prop: "preventDiseases", minWidth: "200px" },
    { label: "操作人", prop: "modifiedBy", width: "100px" },
    { label: "最后操作时间", prop: "modifiedTime", width: "160px" },
    { label: "操作", prop: "action", width: "150px" }
  ];

  mounted() {
    this.getFilterOptions();
    this.getData();
  }

  getFilterOptions() {
    getWeigherMetabolismConfigFilterOptions().then((res) => {
      this.tongueConstitutionOptions = (res.data?.resultKey1List || []).map((item: string) => ({
        label: item,
        value: item
      }));
      this.bodyFatTypeOptions = (res.data?.resultKey2List || []).map((item: string) => ({
        label: item,
        value: item
      }));
    });
  }

  searchData() {
    this.resetCurrent();
    this.getData();
  }

  getData() {
    const params = {
      pageNum: this.currentPage,
      pageSize: this.pageSize,
      resultKey1: this.queryForm.tongueConstitution || undefined,
      resultKey2: this.queryForm.bodyFatType || undefined,
    };
    this.showLoading();
    getWeigherMetabolismConfigPage(params).then((res) => {
      this.tableData = res.data?.list || [];
      this.itemTotal = res.data?.total || 0;
    }).finally(() => {
      this.hideLoading();
    });
  }

  handleEdit(row: any) {
    this.currentRow = row;
    this.EditDialogVisible = true;
  }

  editConfirm() {
    this.getData();
    this.EditDialogVisible = false;
  }

  formatTextarea(content) {
    return formatTextarea(content);
  }
}
